import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from 'src/app/core/services/account.service';
import { PreInitSettingsService } from '../../../../core/services/settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { GTMOnboardingEvents, OnboardingSteps } from 'src/app/model/google-tag-manager/api-status';

enum AccountSetupFlow {
  confirmEmail,
  password,
  success,
  extraInformation
}

@Component({
  selector: 'app-signup-invite',
  templateUrl: './signup-invite.component.html',
  styleUrls: ['./signup-invite.component.scss']
})
export class SignupInviteComponent implements OnInit {
  AccountSetupFlow = AccountSetupFlow;
  heading: string;
  currentScreenFlow: AccountSetupFlow = AccountSetupFlow.confirmEmail;
  inviteId: string;
  emailAddress: string;
  password: string;
  isSignupCompleting: boolean = false;
  isAuthenticated = false;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  isLoading = true;
  userAlreadyInOkta: boolean;
  showOtpScreen = false;
  public isElitaEnabled : boolean = false;

  constructor(
    private accountService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private preInitAppSettings: PreInitSettingsService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit() {
    this.heading = this.resourceService.getViewLabel('Signup_InvitedUser_Heading_Text');
    this.isElitaEnabled = this.resourceService.isPortalSettingTrue('Global_CTC_IsElita');
    this.route.queryParams.subscribe(params => {
      this.inviteId = params.inviteId;
      const groupId = this.preInitAppSettings.getSiteSettings().groupId;
      this.accountService.getSecondarySignup(this.inviteId, groupId).subscribe(
        (resp) => {
          this.isLoading = false;
          this.emailAddress = resp.emailAddress;
          this.userAlreadyInOkta = resp.userAlreadyInOkta;
          this.firstName = resp.firstName;
          this.lastName = resp.lastName;
          this.phoneNumber = resp.phoneNumber;
          this.googleAnalyticsService.isPrimary = false;
        },
        (error) => {
          this.isLoading = false;
          if (error?.error?.type === 'error') {
            throw error;
          }
          else if (error?.error?.ErrorCode == "InvitationExpired" || error?.error?.ErrorCode == "InvitationNotFound") {
            this.router.navigate(['/invite-expired']);
          } else {
            throw error;
          }
        }
      );
    });
  }

  emailConfirmed() {
    this.currentScreenFlow = AccountSetupFlow.extraInformation;
  }

  passwordChanged(event) {
    this.password = event.password;
    this.signup();
  }

  extraInformationComplete(event) {
    this.firstName = event.firstName;
    this.lastName = event.lastName;
    this.phoneNumber = event.phoneNumber;
    if (this.userAlreadyInOkta) {
      this.signup();
    } else {
      this.currentScreenFlow = AccountSetupFlow.password;
    }
  }

  signup() {
    this.isSignupCompleting = true;

    if (this.userAlreadyInOkta) {
      this.accountService.postSignupSecondaryOktaExists(this.inviteId, this.phoneNumber, this.firstName, this.lastName)
      .subscribe(() => {
          // Move to success flow
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.CreateLogin);
          this.currentScreenFlow = AccountSetupFlow.success;
        }, (err) => {
          const emitError = {
            message: err?.error?.Message,
            type: err?.error?.ExceptionType,
            code: err?.error?.ErrorCode,
          }
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Failed, OnboardingSteps.CreateLogin, emitError);
          this.isSignupCompleting = false;
          throw err;
        },
          () => this.isSignupCompleting = false
        );
    } else {
      this.accountService.postSignupSecondary(this.inviteId, this.password, this.phoneNumber, this.firstName, this.lastName)
      .subscribe(() => {
          // Move to success flow
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Complete, OnboardingSteps.CreateLogin);
          this.currentScreenFlow = AccountSetupFlow.success;
        }, (err) => {
          const emitError = {
            message: err?.error?.Message,
            type: err?.error?.ExceptionType,
            code: err?.error?.ErrorCode,
          };
          this.googleAnalyticsService.emitOnboardingEvent(GTMOnboardingEvents.Failed, OnboardingSteps.CreateLogin, emitError);
          if (err.error && err.error.Message) {
            if (err.error.Message.indexOf('at Okta.Sdk.Internal') > -1) {
              err.error.Message = err.error.Message.substring(0, err.error.Message.indexOf('at Okta.Sdk.Internal')).trim();
            }
            // TODO: ERROR : Add the Logic in API to raise Error with right ErrorCode

            err.error.CustomTitle = err.error.Message;
          }
          this.isSignupCompleting = false;
          this.currentScreenFlow = AccountSetupFlow.password;
          throw err;
        },
          () => this.isSignupCompleting = false
        );
    }

  }

  previousScreen() {
    switch (this.currentScreenFlow) {
      case AccountSetupFlow.extraInformation:
        if (this.showOtpScreen) {
          this.showOtpScreen = false;
        } else {
          this.currentScreenFlow = AccountSetupFlow.confirmEmail;
        }
        break;
      case AccountSetupFlow.password:
        this.currentScreenFlow = AccountSetupFlow.extraInformation;
        this.showOtpScreen = false;
        break;
      default:
        break;
    }
  }

  changeHeading() {
    this.heading = this.resourceService.getViewLabel('Signup_Success_Heading_Text');
  }

  // login controls not loading to close button is handled here
  onClose() {
    this.router.navigate(['/login'], { queryParamsHandling: 'preserve' }).then(
      () => { window.location.reload(); });
  }
}
